import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericDocHdrLineOpenQueueContainerModel, GenericDocHdrLineOpenQueueImportContainerModel, GenericDocumentHdrLineContainerModel, RecurringGenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';


export class RecurringBaseGenDocTypeService extends BaseApiTemplateService<RecurringGenericDocContainerModel> {

  public docType: string;
  attachmentUrl: string;

  constructor(http: HttpClient, docType: string) {
    super();
    this.docType = docType;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_DOC_PREFIX + Core2Config.RECURRING_PREFIX;
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_DOC_PREFIX}${Core2Config.RECURRING_PREFIX}${this.docType}/backoffice-ep`;
    this.endpoint_path_event_view_url = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_DOC_PREFIX}${Core2Config.RECURRING_PREFIX}${this.docType}/event-view/backoffice-ep`;
    this.attachmentUrl =  `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_DOC_PREFIX}${Core2Config.RECURRING_PREFIX}attachments/${this.docType}/backoffice-ep`;
    this.httpClient = http;
  }
}
